const Fn = [
    100,100,100,300,300,500,1000,1000,2000,3000
    //1,1,1,1,0.6,0.4,0.4,0.2,0.2,0.09
]


const trainingSuccessRequireReducer = (state = Fn, action) => {
    switch(action.type){
        default:
            return state;
    }
}
export default trainingSuccessRequireReducer;